import { render, staticRenderFns } from "./FDProfile.vue?vue&type=template&id=159a367f&scoped=true&"
import script from "./FDProfile.vue?vue&type=script&lang=js&"
export * from "./FDProfile.vue?vue&type=script&lang=js&"
import style0 from "./FDProfile.vue?vue&type=style&index=0&id=159a367f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159a367f",
  null
  
)

export default component.exports